export default {
    CONFIG: {},
    EVENTS: {
        PUBLIC_USER_LANDING: 'RAPPYTRAVEL_PUBLIC_USER_LANDING',
    },
  };
/*
README: follow instructions for event creation on https://docs.google.com/presentation/d/1gw9sSaG7qX1AxD6mxnbQkxo9WdbyleWuY1Mi4cb4KgI/edit#slide=id.g705c2dbd2b_2_17
*/